// @ts-nocheck
import { YStack, XStack, Text } from 'tamagui';
import { Fingerprint, ShieldCheck, Receipt, UsersThree } from '@phosphor-icons/react';
import { GridBand, IconCell } from './GridBand';
import { useIsMobile } from '../hooks/useIsMobile';

/**
 * Pillar one — the thesis.
 *
 * Split so the claim stays fixed on the left while the four shared pieces read
 * down the right. The claim alone sounds like positioning; the list alone reads
 * as a feature dump. Beside each other, the second is evidence for the first.
 *
 * Runs before the product roster on purpose: without it eight products read as
 * unfocused, and with it the roster becomes evidence the foundation works.
 */
const shared = [
  {
    Icon: Fingerprint,
    title: 'One identity',
    body: 'SSO and directory sync. A person exists once across every product, not once per product.',
  },
  {
    Icon: ShieldCheck,
    title: 'One permission model',
    body: 'Resource-based RBAC down to individual tools, with the same grant and request flow everywhere.',
  },
  {
    Icon: Receipt,
    title: 'One bill',
    body: 'Seat and usage billing with customer-set spend caps. A second product lands on the same invoice.',
  },
  {
    Icon: UsersThree,
    title: 'One org structure',
    body: 'Organizations, teams and members carry across. Adding a product is a switch, not a migration.',
  },
];

export function Platform() {
  const isMobile = useIsMobile();

  return (
    <GridBand
      eyebrow="The platform"
      title="One platform underneath."
      lede="Identity, organizations, teams, permissions and billing are solved once and shared. A customer who adopts a second product keeps their org, their members and their access model — adoption is a switch, not a migration."
      split
      tint
    >
      <YStack borderTopWidth={1} borderColor="$color3">
        {shared.map((item) => (
          <XStack
            key={item.title}
            gap="$4"
            paddingVertical={isMobile ? '$4' : '$5'}
            borderBottomWidth={1}
            borderColor="$color3"
            alignItems="flex-start"
          >
            <IconCell size={isMobile ? 38 : 44}>
              <item.Icon size={isMobile ? 17 : 19} color="var(--amber9)" weight="regular" />
            </IconCell>

            <YStack gap="$1" flex={1}>
              <Text fontSize={isMobile ? '$5' : '$6'} fontWeight="600" color="$color11">
                {item.title}
              </Text>
              <Text fontSize="$3" color="$color8" lineHeight={21}>
                {item.body}
              </Text>
            </YStack>
          </XStack>
        ))}
      </YStack>
    </GridBand>
  );
}
